import { create } from 'zustand';

const useNotificationStore = create((set) => ({
  notification: null,

  setNotification: (notification) => set({ notification }),

  clearNotification: () => set({ notification: null }),

  showNotification: (type, message, duration = 3000) => {
    set({ notification: { type, message } });

    if (duration > 0) {
      setTimeout(() => {
        set({ notification: null });
      }, duration);
    }
  },

  showSuccess: (message, duration = 3000) => {
    set({ notification: { type: 'success', message } });

    if (duration > 0) {
      setTimeout(() => {
        set({ notification: null });
      }, duration);
    }
  },

  showError: (message, duration = 5000) => {
    set({ notification: { type: 'error', message } });

    if (duration > 0) {
      setTimeout(() => {
        set({ notification: null });
      }, duration);
    }
  },

  showWarning: (message, duration = 4000) => {
    set({ notification: { type: 'warning', message } });

    if (duration > 0) {
      setTimeout(() => {
        set({ notification: null });
      }, duration);
    }
  },

  showInfo: (message, duration = 3000) => {
    set({ notification: { type: 'info', message } });

    if (duration > 0) {
      setTimeout(() => {
        set({ notification: null });
      }, duration);
    }
  },
}));

export default useNotificationStore;
